import { createContext } from "react";
import { ADCubeConfigService } from "../service/ADCubeConfigService";

export const ADCubeAdminContext = createContext({
  authenticated: ADCubeConfigService.isLogged(),
  setAuthenticated: () => {},
  themeLight: true,
  setThemeLight: () => {},
});
